<template>
  <div class="hero is-fullheight has-background">
    <div class="hero-background"></div>
    <div class="hero-body" style="margin: 0; padding: 0">
      <div class="container is-fluid" style="margin: 0; padding: 0">
        <div v-if="user" class="columns" style="height: 100vh; margin: 0">
          <div
            v-if="
              user.hasProfil != true &&
              user.hasResult != true &&
              user.hasSurvey != true
            "
            class="column"
            style="background: #005960"
          >
            <font-awesome-icon
              icon="fa-regular fa-face-grin-beam-sweat"
              size="6x"
            />
            <p class="title">COMPTE INCONNU</p>
            <p>Bonjour,</p>
            <p>
              Nous n'avons pas pu trouver d'informations liées à votre email de
              connexion.
            </p>
            <p>
              Merci de revenir vers votre conseiller MH-Conseil en lui notifiant
              ce problème ou d'écrire à questionnaires@mh-conseil.com.
            </p>
          </div>
          <div v-if="user.hasProfil" class="column" style="background: #005960">
            <router-link to="/Profil">
              <font-awesome-icon icon="fa-regular fa-user" size="6x" />
              <p class="title">VOTRE PROFIL</p>
              <p>Consulter et Modifier mes données personnelles ></p>
            </router-link>
          </div>
          <div v-if="user.hasSurvey" class="column" style="background: #a4906f">
            <router-link v-if="user.hasProfil" to="/Survey/itp">
              <font-awesome-icon icon="fa-solid fa-file-pen" size="6x" />
              <p class="title">MES QUESTIONNAIRES</p>
              <p>Mes questionnaires à compléter ></p>
            </router-link>
            <router-link
              v-if="user.hasProfil == false"
              :to="{ name: 'Profil', params: { fromSurveyType: 'itp' } }"
            >
              <font-awesome-icon icon="fa-solid fa-file-pen" size="6x" />
              <p class="title">MES QUESTIONNAIRES</p>
              <p>Mes questionnaires à compléter ></p>
            </router-link>
          </div>

          <div v-if="user.hasResult" class="column" style="background: #21202e">
            <router-link to="/Results" class="is-white">
              <font-awesome-icon icon="fa -solid fa-chart-column" size="6x" />
              <p class="title">MES R&Eacute;SULTATS</p>
              <p>Consulter et télécharger le résultat de mes études ></p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      hasSurvey: false,
      hasResult: false,

      error: null,
    };
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user",
    }),
  },
};
</script>

<style scoped>
.column {
  text-align: center;
  padding-top: 25vh;
}
.hero-body,
a {
  color: #f9f9f9;
}
.title {
  margin-top: 20px;
  color: inherit;
}

a:hover,
.hero-body:hover {
  color: #aaaaaa;
}
</style>
